import { LOGOUT } from '../constants/actionTypes';

const logout = () => ({
    type: LOGOUT,
  });

export default logout;
